import { render, staticRenderFns } from "./PhotoBookPageList.vue?vue&type=template&id=891f575e&scoped=true"
import script from "./PhotoBookPageList.vue?vue&type=script&lang=js"
export * from "./PhotoBookPageList.vue?vue&type=script&lang=js"
import style0 from "./PhotoBookPageList.vue?vue&type=style&index=0&id=891f575e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891f575e",
  null
  
)

export default component.exports